document.addEventListener("DOMContentLoaded", () => {
  // Initialize each slider instance separately
  document.querySelectorAll(".section--video-slider").forEach((slider) => initVideoSlider(slider));

  // Re-initialize when sections load in the theme editor
  document.addEventListener("shopify:section:load", (event) => {
    const slider = event.target.querySelector(".slider");
    if (slider) initVideoSlider(slider);
  });

  // Global click delegation for nav arrows
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".custom--flickity-arrow.flickity-nav");
    if (!btn) return;
    const ugcSlider = btn.closest(".ugc-video-slider");
    if (!ugcSlider) return;

    const group = ugcSlider.querySelector(
      '.videos-group.carousel[style*="display: block"]'
    );
    if (!group) return;
    const flkty = Flickity.data(group);
    if (!flkty) return;

    btn.classList.contains("flickity-prev") ? flkty.previous() : flkty.next();
    updateNavButtonVisibility(ugcSlider, flkty);
  });
});

function initVideoSlider(container) {
  setupVideos(container);
}

function setupVideos(container) {
  container.querySelectorAll(".video-container").forEach((videoContainer) => {
    const video = videoContainer.querySelector("video");
    const playBtn = videoContainer.querySelector(".play-button");
    const pauseBtn = videoContainer.querySelector(".pause-button");
    const muteBtn = videoContainer.querySelector(".mute-button");
    const unmuteBtn = videoContainer.querySelector(".unmute-button");
    if (!video || !playBtn || !pauseBtn || !muteBtn || !unmuteBtn) return;

    let userPaused = false;
    
    if (videoContainer.observer) videoContainer.observer.disconnect();
    
    ensureVideoIsReady(video);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !userPaused) {
            playVideoWhenReady(video, () => {
              playBtn.style.display = "none";
              pauseBtn.style.display = "block";
            });
          } else {
            video.pause();
            pauseBtn.style.display = "none";
            playBtn.style.display = "block";
          }
        });
      },
      { threshold: 0.2 }
    );
    videoContainer.observer = observer;
    observer.observe(videoContainer);

    // Replace buttons to strip old listeners
    const np = playBtn.cloneNode(true);
    const npa = pauseBtn.cloneNode(true);
    const nm = muteBtn.cloneNode(true);
    const nu = unmuteBtn.cloneNode(true);
    playBtn.replaceWith(np);
    pauseBtn.replaceWith(npa);
    muteBtn.replaceWith(nm);
    unmuteBtn.replaceWith(nu);

    const [up, pa, mu, um] = [
      videoContainer.querySelector(".play-button"),
      videoContainer.querySelector(".pause-button"),
      videoContainer.querySelector(".mute-button"),
      videoContainer.querySelector(".unmute-button"),
    ];

    up.addEventListener("click", () => {
      userPaused = false;
      playVideoWhenReady(video, () => {
        up.style.display = "none";
        pa.style.display = "block";
      });
    });

    pa.addEventListener("click", () => {
      userPaused = true;
      video.pause();
      pa.style.display = "none";
      up.style.display = "block";
    });

    video.addEventListener("click", () => {
      if (video.paused) {
        playVideoWhenReady(video, () => {
          up.style.display = "none";
          pa.style.display = "block";
        });
      } else {
        video.pause();
        pa.style.display = "none";
        up.style.display = "block";
      }
    });

    mu.addEventListener("click", (e) => {
      e.stopPropagation();
      video.muted = true;
      um.style.display = "block";
      mu.style.display = "none";
    });

    um.addEventListener("click", (e) => {
      e.stopPropagation();
      // mute all others
      container.querySelectorAll(".video-container").forEach((otherVideoContainer) => {
        const otherVideo = otherVideoContainer.querySelector("video");
        if (otherVideo && otherVideo !== video && !otherVideo.muted) {
          otherVideo.muted = true;
          otherVideoContainer.querySelector(".unmute-button").style.display = "block";
          otherVideoContainer.querySelector(".mute-button").style.display = "none";
        }
      });
      video.muted = false;
      um.style.display = "none";
      mu.style.display = "block";
    });

    video.addEventListener("ended", () => {
      userPaused = false;
      up.style.display = "block";
      pa.style.display = "none";
    });
  });
}

function ensureVideoIsReady(video) {
  if (!video.src && video.dataset.src) {
    video.classList.add("lazy-video");
  }
}

function playVideoWhenReady(video, callback) {
  if (
    video.classList.contains("lazy-video") &&
    !video.classList.contains("initialized")
  ) {
    video.addEventListener(
      "canplay",
      () => {
        video.play().catch(() => {
          console.log("Autoplay prevented by browser policy");
        });
        callback?.();
      },
      { once: true }
    );
    video.src = video.dataset.src;
    video.load();
    video.classList.add("initialized");
  } else {
    video.play().catch(() => {
      console.log("Autoplay prevented by browser policy");
    });
    callback?.();
  }
}